var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overlay"},[_c('div',{staticClass:"overlay-content"},[_c('div',{staticClass:"slogan sofiaBold"},[_c('div',{staticClass:"slogan-title"},[_vm._v("科技·让保险更简单")]),_c('div',{staticClass:"slogan-subtitle"},[_vm._v("数智化保险服务平台")])])])])
}]

export { render, staticRenderFns }